<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('sidebar.dmlrim')" />
      <h3>{{ $t('sidebar.dmlrim') }}</h3>
      <div
        v-if="showDashboard===0"
        class="row"
      >
        <div class="col-lg-8">
          <div
            v-if="invoices.length<1"
            class="alert alert-info"
          >
            {{ $t('invoicesPage.heBirInvoysQeydAlnmamdr') }}
          </div>

          <div
            v-for="o in invoices"
            :key="o.id"
            class="card"
            style="cursor: pointer"
            @click.prevent="showInvoice(o.id)"
          >
            <div class="card-header lead f-w-600">
              <div class="d-flex justify-content-between">
                <div> {{ $t('invoicesPage.invoice', {id: o.id}) }}</div>
                <div>
                  <div v-if="o.amount>0">
                    {{ $t('invoicesPage.oamountAzn' , {amount: o.amount}) }}
                  </div>
                  <div v-else>
                    {{ $t('invoicesPage.pulsuz') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              {{ $t('invoicesPage.key', {profileType: getProfileName(o.profileType), name: o.packagePeriod.name}) }}
            </div>
            <div class="card-footer">
              <div class="d-flex justify-content-between">
                <div> {{ getMoment(o.logTime) }}</div>
                <div>
                  <div
                    class="badge badge-primary"
                    :class="{
                      'badge-success': o.status ==='paid',
                      'badge-danger': o.status ==='failed',
                    }"
                  >
                    {{ getInvoiceStatusText(o.status) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{ $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {name: company.name, getCompanyFormat: getCompanyFormat(company.format)}) }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }} <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="row"
      >
        <div class="col-sm-12 p-0">
          <div class="auth-innerright">
            <div class="authentication-box" />
            <div class="card mt-4 p-4">
              <div
                class="alert alert-primary text-center my-4"
                style="padding: 50px 20px;"
              >
                <feather
                  type="clock"
                  size="40"
                />
                <br>
                <span v-if="showDashboard===1">
                  {{
                    $t('dashboardVue.sizinBuIrktQoulmanzNIrktinizinAdminiTrfindnTsdiqln', {
                      adminName: company.adminName,
                      adminSurname: company.adminSurname
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getInvoices, userAccounts,} from "@/repositories/GeneralDataRepository";
import {mediaBase, paymentDomain} from "@/repositories/Repository";
import moment from "moment/moment";
import {
  buildLongId,
  getCompanyFormat,
  getPhoto,
  getProfileName
} from "@/repositories/Utils";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      paymentDomain: paymentDomain,
      invoices: [],
      showDashboard: 0,
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {
    this.userAccount();
    this.timer = setInterval(() => {
      this.userAccount();
    }, 5000)
    this.getInvoices();

  },
  methods: {
    userAccount() {

      userAccounts(this.token).then(data => {
        this.profiles = data;this.profiles = data;
        let ae = data.filter(profile => {
          return profile.company.id === this.company.id && profile.profileType === this.profile;
        });

        if (ae.length > 0 && this.company.adminName) {
          this.showDashboard = (ae[0].status === "verified") ? 0 : 1;
        }
        if (this.showDashboard === 0) {
          clearInterval(this.timer);
        }
        // this.showDashboard = (this.company.status === "VERIFIED" || this.company.status==="CONFIRMED") ? 0 : 2;
      });
    },
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getInvoices() {
      getInvoices(this.token, this.$i18n.locale).then(data => {
        if (data.code === 200) {

          this.invoices = data.invoices;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },
    showInvoice(id) {
      window.open(`${this.paymentDomain}/invoice.php?invoice=${id}`)
    },
    getInvoiceStatusText(status) {
      const statusTranslationKeys = {
        new: "invoice_status_new",
        paid: "invoice_status_paid",
        failed: "invoice_status_failed",
        expired: "invoice_status_expired"
      };
      const translationKey = statusTranslationKeys[status];
      return translationKey ? this.$t(`paymentStatus.${translationKey}`) : status;
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
